const MODE_LABELS = {
  identity_backed: 'Identity-backed candidates',
  amount_review: 'Amount-only review candidates',
  non_customer_movement: 'Non-customer movement candidate',
  no_candidates: 'No valued candidates',
}

export function candidateEvidencePresentation(evidence = {}) {
  const profile = evidence.profile || 'payment-candidates-v1'
  const legacy = profile !== 'payment-candidates-v2'
  const mode = legacy ? 'legacy' : (evidence.mode || 'no_candidates')
  const warning = legacy
    ? 'Legacy evidence predates explicit candidate modes.'
    : mode === 'amount_review'
      ? 'Amount-only bundles do not establish payer or customer identity. A collector must verify the allocation.'
      : mode === 'non_customer_movement'
        ? 'This is a deterministic non-customer movement candidate, not a settled accounting classification.'
        : null
  return {
    profile,
    legacy,
    mode,
    modeLabel: legacy ? 'Legacy candidate evidence' : (MODE_LABELS[mode] || mode),
    warning,
    classificationCode: evidence.classification_code || null,
    searchComplete: evidence.search_complete !== false && evidence.truncated !== true,
    searchLimitReasons: Array.isArray(evidence.search_limit_reasons) ? evidence.search_limit_reasons : [],
    unvaluedInvoiceCount: Number(evidence.unvalued_invoice_count || 0),
    bundles: Array.isArray(evidence.bundles) ? evidence.bundles : [],
  }
}

export function hasConfirmableProposal(review = {}) {
  const match = review.match || review.result || review.payment?.match || {}
  const invoiceIds = Array.isArray(match.matched_invoice_ids) ? match.matched_invoice_ids : []
  const allocation = match.allocation && typeof match.allocation === 'object'
    ? match.allocation
    : {}
  return invoiceIds.length > 0 && invoiceIds.every((invoiceId) => {
    const amount = Number(allocation[invoiceId])
    return Number.isFinite(amount) && amount > 0
  })
}
